import { restoreScroll } from '../router.js';
import { backButton } from '../components/branding.js';
import { emptyState, errorCard, loaderView, wireRetry } from '../components/feedback.js';
import { renderAppScreen } from '../components/shell.js';
import { topicRow, wireThumbnails } from '../components/topicRow.js';
import { getFavoriteTopics, removeFavorite } from '../study/favorites.js';
import { getDoneTopicIds } from '../study/completion.js';

const EMPTY = [
  'Brak ulubionych',
  'Dodaj temat do ulubionych, dotykając serduszka na jego ekranie.',
];

/* -------------------------------------------------------------------------- */
/* Screen                                                                     */
/* -------------------------------------------------------------------------- */

/**
 * Read the favorited ids from the `favorites` store, resolve each one to its
 * `topics_head` row and render the shared topic rows — with the heart slot on,
 * so a row can be un-starred straight from the list.
 *
 * The completed ids come from their own store (`topics_done`) in the same breath:
 * a head row carries no completion of its own, and this list shows the same green
 * check the chapter list does.
 */
async function loadFavorites(main) {
  const region = main.querySelector('#favorites-region');
  region.innerHTML = loaderView('Wczytywanie ulubionych…', { fullscreen: false });

  let topics = [];
  let doneIds = new Set();
  try {
    topics = await getFavoriteTopics();
    doneIds = await getDoneTopicIds();
  } catch (error) {
    region.innerHTML = errorCard(error, 'Nie udało się wczytać ulubionych.');
    wireRetry(region, () => loadFavorites(main));
    return;
  }

  if (!topics.length) {
    region.innerHTML = emptyState(...EMPTY, { fill: true });
    return;
  }

  region.innerHTML = `<ul class="flex flex-col gap-3">${topics
    .map((topic) => topicRow(topic, { favorite: true, done: doneIds.has(topic.id) }))
    .join('')}</ul>`;
  wireThumbnails(region, topics);
  restoreScroll(); // the list is in the DOM — return to where the user left it

  // Un-star from the list: drop the row from the store, then from the DOM.
  region.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    const topicId = btn.dataset.favoriteToggle;
    btn.disabled = true;
    try {
      await removeFavorite(topicId);
    } catch {
      btn.disabled = false; // IndexedDB unavailable — keep the row as it was
      return;
    }
    region.querySelector(`[data-topic-row="${CSS.escape(topicId)}"]`)?.remove();
    if (!region.querySelector('[data-topic-row]')) {
      region.innerHTML = emptyState(...EMPTY, { fill: true });
    }
  });
}

/** "Ulubione" — the topics starred from the topic screen, read from IndexedDB. */
export function renderFavorites(mount) {
  const content = `
    <div class="flex flex-1 flex-col py-8">
      <h1 class="text-2xl font-semibold tracking-tight text-neutral-900">Ulubione</h1>
      <p class="mt-1 text-sm leading-relaxed text-neutral-500">Tematy zapisane na później.</p>
      <section id="favorites-region" class="mt-6 flex flex-1 flex-col"></section>
    </div>`;

  renderAppScreen(mount, {
    active: 'favorites',
    contentHtml: content,
    leading: backButton(),
    onMount(main) {
      loadFavorites(main);
    },
  });
}
